import { Button } from "antd";
import { SyncOutlined } from "@ant-design/icons";

export const RefreshBtn = ({ icon, ...others }) => {
  return (
    <Button
      icon={icon ? <SyncOutlined /> : null}
      onClick={() => window.location.reload()}
      {...others}
    >
      Actualizar página
    </Button>
  );
};
